<template>
  <el-tag effect="dark" :type="status | statusColorFilter(updatedAt)">
    <strong>
      {{ status | statusFilter(updatedAt) }}
    </strong>
  </el-tag>
</template>
<script>
import dayjs from 'dayjs';
const disconnectTime = dayjs().subtract(10, 'minutes');
export default {
  filters: {
    statusFilter(key, updatedAt) {
      const disconnect = dayjs(updatedAt).isBefore(disconnectTime);
      const map = {
        2: '連線中',
        4: '未註冊',
      };
      if (disconnect && key === 1) return '斷線';
      return map[key] ? map[key] : '正常';
    },
    statusColorFilter(key, updatedAt) {
      const disconnect = dayjs(updatedAt).isBefore(disconnectTime);
      const map = {
        2: 'danger',
        4: 'warning',
      };
      if (disconnect && key === 1) return 'danger';
      return map[key] ? map[key] : 'success';
    },
  },
  props: {
    status: {},
    updatedAt: {},
  },
};
</script>
